import { getCookieValue } from './cookieLib';

export const SUPPRESS_LEAVE_PROMPT_COOKIE_KEY = 'e2eSuppressLeavePrompt';

/**
 * True when the browser carries the `e2eSuppressLeavePrompt` cookie, which exists for automated
 * browser tests: the browser's own "leave site?" dialog is a native window that a test driver
 * cannot answer reliably, so while the cookie is set the app does not arm `beforeunload`. The
 * in-app Save / Discard / Cancel modal is unaffected. Read it when the event fires, not once.
 */
export const leavePromptSuppressed = (): boolean => !!getCookieValue(SUPPRESS_LEAVE_PROMPT_COOKIE_KEY);
